export enum SelectType {
  ANY = "ANY",
  AND = "AND",
  ONLY = "ONLY"
}
